import styled from 'styled-components';

import authBackground from 'assets/images/authBackground.jpg';
export const Background = styled.div`
  height: 100vh;
  background-image: url(${authBackground});
  background-size: cover;
  display: flex;
  flex-flow: column;
`;

export const Sticky = styled.div`
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
`;
